<template>
  <div>
    <b-row v-if="unverifiedMentions.length">
      <b-col>
        <b-card no-body class="mentions-card">
          <b-card-header class="mentions-header">
            <i class="fas fa-users mr-2"></i>
            <strong>Menções</strong>
          </b-card-header>
          <b-card-body class="mentions-body">
            <div class="mentions-description">
              <i class="fas fa-info-circle text-info mr-2"></i>
              Essa denúncia pode conter menção à algum dos usuários. Avalie as
              informações abaixo nas seções destacadas e confirme ou
              desconsidere a menção.
            </div>

            <div class="mentions-list">
              <div
                v-for="mention in unverifiedMentions"
                :key="`${mention._id}-${mention.verified}-${mention.blocked}`"
                class="mention-item"
                :class="{ 'mention-active': currentMention === mention }"
              >
                <div class="mention-user-info">
                  <div class="user-avatar">
                    <i class="fas fa-user"></i>
                  </div>
                  <div class="user-details">
                    <span class="user-name"
                      >{{ mention.user.name }} {{ mention.user.surname }}</span
                    >
                    <span class="user-status">Aguardando avaliação</span>
                  </div>
                </div>

                <div class="mention-actions">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="action-btn highlight-btn"
                    @click="onHighlight(mention)"
                  >
                    <i class="fas fa-search mr-1"></i>
                    Destacar
                  </b-button>
                  <b-button
                    variant="success"
                    size="sm"
                    class="action-btn confirm-btn"
                    @click="onConfirm(mention)"
                  >
                    <i class="fas fa-ban mr-1"></i>
                    Manter Bloqueio
                  </b-button>
                  <b-button
                    variant="danger"
                    size="sm"
                    class="action-btn discard-btn"
                    @click="onDiscard(mention)"
                  >
                    <i class="fas fa-check mr-1"></i>
                    Remover Bloqueio
                  </b-button>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-else-if="mentions.length">
      <b-col>
        <b-card no-body class="mentions-card">
          <b-card-header class="mentions-header">
            <i class="fas fa-users mr-2"></i>
            <strong>Menções</strong>
          </b-card-header>
          <b-card-body class="mentions-body">
            <div class="mentions-description">
              <i class="fas fa-check-circle text-success mr-2"></i>
              Foi feito tratamento de possíveis menções nessa denúncia.
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "MentionsPanel",
  props: {
    mentions: {
      type: Array,
      default: () => [],
    },
    currentMention: {
      type: Object,
      default: null,
    },
  },
  computed: {
    unverifiedMentions() {
      return this.mentions.filter((mention) => !mention.verified);
    },
  },
  methods: {
    onHighlight(mention) {
      this.$emit("update:currentMention", mention);
    },
    onConfirm(mention) {
      this.$emit("confirm", mention);
    },
    onDiscard(mention) {
      this.$emit("discard", mention);
    },
  },
};
</script>

<style scoped>
/* Estilos modernos para a seção de menções */
.mention-item {
  background: white;
  border-radius: 10px;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.mention-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.mention-active {
  border-color: #007bff;
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  box-shadow: 0 4px 16px rgba(0, 123, 255, 0.15);
}

.mention-user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1;
}

.user-avatar {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3);
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.user-name {
  font-weight: 600;
  font-size: 1.1rem;
  color: #2c3e50;
}

.user-status {
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}

.mention-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.action-btn {
  border-radius: 8px;
  font-weight: 500;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease;
  border: none;
  min-width: 100px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.highlight-btn {
  background: #e3f2fd;
  color: #1976d2;
  border: 2px solid #1976d2;
}

.highlight-btn:hover {
  background: #1976d2;
  color: white;
}

.confirm-btn {
  background: #dc3545;
  color: white;
  border: 2px solid #dc3545;
}

.confirm-btn:hover {
  background: #c82333;
  border-color: #c82333;
  color: white;
}

.discard-btn {
  background: #28a745;
  color: white;
  border: 2px solid #28a745;
}

.discard-btn:hover {
  background: #218838;
  border-color: #218838;
  color: white;
}

/* Responsividade */
@media (max-width: 768px) {
  .mention-item {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .mention-actions {
    justify-content: center;
    flex-wrap: wrap;
  }
  .action-btn {
    min-width: 80px;
    font-size: 0.85rem;
  }
}

/* Estilo original mantido para compatibilidade */
.mention.active {
  background: lightblue;
  color: black;
}
</style>
